<template>
    <div class="select-treatment-container">
        <div class="cita-header">
            <BackButton />
            <div class="titulo">Elige el día y la hora de tu cita</div>
        </div>

        <!--         <p style="font-size: 0.8rem">
            En tu primera visita, serás valorado por un equipo de doctores especializados y te realizaremos
            diferentes pruebas radiográficas para obtener un diagnóstico preciso.
        </p> -->
        <div style="display: none"><BackButton /></div>
        <div v-if="isLoading" class="loader-overlay">
            <div class="loader-container">
                <div class="spinner"></div>
                <p>
                    Estamos buscando las mejores opciones de citas disponibles para ti.
                    <br />
                    <br />
                    Por favor, espera un momento...
                </p>
            </div>
        </div>
        <div class="contenedor" v-else>
            <!-- Botón de flecha para volver -->
            <ErrorModal :show="showErrorModal" :message="errorMessage" @close="handleModalClose" />
            <div class="custom-navigation">
                <select v-model="selectedMonth" @change="handleMonthChange" class="month-select">
                    <option v-for="month in availableMonths" :key="month.value" :value="month.value">
                        {{ month.label }}
                    </option>
                </select>
                <!-- eslint-disable-next-line -->
                <button @click="slidePrev" class="nav-button prev-button">
                    <svg
                        height="10"
                        width="10"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 330 330"
                        xml:space="preserve"
                    >
                        <g transform="scale(-1, 1) translate(-330, 0)">
                            <path
                                d="m250.606 154.389-150-149.996c-5.857-5.858-15.355-5.858-21.213.001-5.857 5.858-5.857 15.355.001 21.213l139.393 139.39L79.393 304.394c-5.857 5.858-5.857 15.355.001 21.213C82.322 328.536 86.161 330 90 330s7.678-1.464 10.607-4.394l149.999-150.004a14.996 14.996 0 0 0 0-21.213z"
                            />
                        </g>
                    </svg>
                </button>
                <button @click="slideNext" class="nav-button next-button">
                    <svg
                        height="10"
                        width="10"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 330 330"
                        xml:space="preserve"
                    >
                        <path
                            d="m250.606 154.389-150-149.996c-5.857-5.858-15.355-5.858-21.213.001-5.857 5.858-5.857 15.355.001 21.213l139.393 139.39L79.393 304.394c-5.857 5.858-5.857 15.355.001 21.213C82.322 328.536 86.161 330 90 330s7.678-1.464 10.607-4.394l149.999-150.004a14.996 14.996 0 0 0 0-21.213z"
                        />
                    </svg>
                </button>
            </div>
            <swiper-container
                ref="swiper"
                :slides-per-view="5"
                :space-between="spaceBetween"
                :centered-slides="false"
                :navigation="false"
                :pagination="false"
                :grabCursor="true"
                :breakpoints="{
                    768: {
                        slidesPerView: 5,
                    },
                }"
            >
                <swiper-slide v-for="(date, index) in dates" :key="index" @click="selectDate(date)">
                    <div>
                        <div v-if="loadingDates.includes(date)" class="day-card">
                            <div class="loading-spinner">
                                <div class="spinner"></div>
                                <p>Cargando citas...</p>
                            </div>
                        </div>
                        <div
                            class="day-card"
                            :class="[isSelected(date) ? 'selected' : '', getSlotClass(date)]"
                            v-else
                        >
                            <div class="day">{{ formatDay(date) }}</div>
                            <div class="date">{{ formatDate(date) }}</div>
                            <div class="slots-container">
                                <div class="slots-indicator" :class="getSlotIndicatorClass(date)"></div>
                                <div class="slots-text">{{ getSlotText(date) }}</div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper-container>

            <div v-if="selectedDate" class="slots">
                <div class="meeting-info" v-if="slots.length > 0">
                    <div>Citas disponibles:</div>
                    <div class="duracion">
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm.5-9h4a.5.5 0 000-1h-3.5V5.5a.5.5 0 00-1 0v6a.5.5 0 00.5.5z"
                                fill="#2f3e4a"
                            />
                        </svg>
                        <span>Duración cita: 90 min</span>
                    </div>
                </div>
                <div v-if="slots.length > 0" class="slots-grid">
                    <div
                        @click="selectCita(slot)"
                        v-for="(slot, index) in slots"
                        :key="index"
                        class="slot-item"
                    >
                        {{ slot.fIniAux }}h
                    </div>
                </div>
                <p class="horacita" v-if="slots.length > 0">Elige la hora de tu cita</p>
                <p v-else>Lo sentimos este día no hay citas disponibles</p>
            </div>
        </div>
    </div>
</template>

<script>
// Swiper
import { register } from "swiper/element/bundle";
import "swiper/swiper-bundle.css";
register();

import axios from "@/axios"; // Importa la instancia configurada

import store from "../store";
import BackButton from "@/components/BackButton.vue"; // Importa el botón de retroceso
import ErrorModal from "@/components/ErrorModal.vue"; // Importa el modal de error

export default {
    components: {
        BackButton, // Registra el componente del botón de retroceso
        ErrorModal, // Registra el componente del modal de error
    },
    data() {
        return {
            spaceBetween: 10,
            loadingDates: this.generateDates(), // Estado para las fechas que están cargando
            dates: this.generateDates(),
            selectedDate: null,
            slots: [],
            availableSlots: [],
            availableMonths: [],
            selectedMonth: null,
            showErrorModal: false,
            shouldRedirect: false,
            errorMessage: "",
            isLoading: false, // Estado para el loader
            fechaApi: null, //Controla la fecha inicial para la siguiente petición a la API
        };
    },
    created() {
        this.setDefaultMonth();
    },
    beforeMount() {
        this.isLoading = true; // Mostrar el loader
        this.fechaApi = new Date();
        this.fetchCitasFromApi(this.fechaApi.toISOString().split("T")[0]);
    },
    methods: {
        selectCita(slot) {
            this.$store.commit("setCita", slot);
            this.$router.push({ name: "Datos" });
        },
        loadMoreSlots() {
            this.fetchCitasFromApi(this.fechaApi.toISOString().split("T")[0]);
        },
        async fetchCitasFromApi(startDate) {
            //La fecha pasarla en 2024-07-31 + 7dias
            const fecha = startDate.replace(/-/g, "");
            const clinica = store.state.clinic ? store.state.clinic : 2;
            const tratamiento = store.state.treatment ? store.state.treatment : "conservadora";
            const endpoint = `/damePrimeras/${clinica}/${tratamiento}/${fecha}`;
            //const endpoint = `/damePrimeras/3/ortodoncia/20240729`;
            try {
                const response = await axios.get(endpoint);
                if (response.data.success) {
                    this.processApiData(response.data.message);
                } else {
                    console.log("Error fetching data from API: " + response.data.message);
                    this.showError(
                        "Ha ocurrido un error, y no podemos mostrarle las citas disponibles en este momento. Por favor inténtelo mas tarde."
                    );
                }
            } catch (error) {
                console.log("Error fetching data from API: " + error.message);
                this.showError(
                    "Ha ocurrido un error, y no podemos mostrarle las citas disponibles en este momento. Por favor inténtelo mas tarde."
                );
            } finally {
                this.isLoading = false; // Ocultar el loader
                this.removeWeekFromLoadingDates(startDate); // Eliminar la semana de loadingDates
            }
        },

        processApiData(apiData) {
            if (apiData != null) {
                // Crear un objeto con los huecos existentes, usando la fecha como clave
                const existingSlots = this.availableSlots.reduce((acc, slot) => {
                    acc[slot.date] = slot;
                    return acc;
                }, {});

                // Crear un objeto con los nuevos huecos obtenidos de la API, usando la fecha como clave
                const newSlots = apiData.reduce((acc, slot) => {
                    const date = slot.fecha.replace(/\//g, "-");
                    if (!acc[date]) {
                        acc[date] = {
                            date: date,
                            slots: [],
                        };
                    }
                    acc[date].slots.push(slot);
                    return acc;
                }, {});

                // Limitamos los huecos reales en funcion del tiempo que falta para la fecha a 4-5-6 huecos
                for (const date in newSlots) {
                    const numSlotsToShow = this.calculateNumSlotsToShow(date);
                    newSlots[date].slots = this.filterSlots(newSlots[date].slots); // Filtrar huecos que quedan menos de 4 horas para la cita
                    if (newSlots[date].slots.length > numSlotsToShow) {
                        newSlots[date].slots = this.limitSlots(newSlots[date].slots, numSlotsToShow);
                    }
                }

                // Combinar los huecos existentes con los nuevos huecos
                const combinedSlots = { ...existingSlots, ...newSlots };

                // Actualizar los huecos disponibles con los huecos combinados
                this.availableSlots = Object.values(combinedSlots);
                this.generateAvailableMonths();
            }
            // Cargar la siguiente semana si no se han cargado todas las semanas
            this.fechaApi.setDate(this.fechaApi.getDate() + 7);

            // Si la fecha actual es menor o igual a la última fecha en el array de fechas, cargar más huecos
            if (this.fechaApi <= new Date(this.dates[this.dates.length - 1])) {
                this.loadMoreSlots(this.fechaApi.toISOString().split("T")[0]);
            }
        },

        //Devuelve el numero máximo de slots que se pueden mostrar
        //en funcion de lo cercana que este la fecha al dia de hoy
        calculateNumSlotsToShow(date) {
            const today = new Date();
            const targetDate = new Date(date);
            const diffDays = Math.ceil((targetDate - today) / (1000 * 60 * 60 * 24));

            // Cuanto más lejos esté la fecha, más huecos mostramos (entre 5 y 6)
            if (diffDays <= 21) return Math.random() < 0.5 ? 4 : 5;
            return Math.random() < 0.5 ? 5 : 6;
        },

        //filtra los huecos que quedan menos de 4 horas para la cita
        filterSlots(slots) {
            const now = new Date();
            const fourHoursLater = new Date(now.getTime() + 4 * 60 * 60 * 1000);

            // Filtrar los huecos que quedan menos de 4 horas
            return slots.filter((slot) => {
                const slotDateTime = new Date(`${slot.fecha.replace(/\//g, "-")}T${slot.fIniAux}:00`);
                return slotDateTime > fourHoursLater;
            });
        },

        // Simula carga de trabajo, eliminando slots disponibles, usa un hash para que en funcion de la fecha
        // los huecos no vailen en cada carga.
        limitSlots(slots, maxSlots) {
            const hash = this.hashString(slots[0].fecha); // Usar la fecha como base para el hash
            const selectedSlots = [];
            for (let i = 0; i < slots.length; i++) {
                if ((hash + i) % slots.length < maxSlots) {
                    selectedSlots.push(slots[i]);
                }
            }

            // Si no se han seleccionado suficientes huecos, añadir más de los disponibles
            while (selectedSlots.length < maxSlots && slots.length > 0) {
                selectedSlots.push(slots.shift());
            }

            return selectedSlots;
        },

        hashString(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash |= 0; // Convert to 32bit integer
            }
            return Math.abs(hash);
        },

        removeWeekFromLoadingDates(startDate) {
            const start = new Date(startDate);
            const end = new Date(start);
            end.setDate(start.getDate() + 6);

            const newLoadingDates = this.loadingDates.filter((date) => {
                const d = new Date(date);
                return d < start || d > end;
            });

            this.loadingDates = newLoadingDates; // Actualizar loadingDates con la lista filtrada
        },

        showError(message) {
            //Si da error y no tengo ninguna cita ya cargada, redirijo a la pagina de tratamiento
            if (this.availableSlots.length == 0) {
                this.errorMessage = message;
                this.showErrorModal = true;
                this.shouldRedirect = true;
            } else {
                // Cargar la siguiente semana si no se han cargado todas las semanas
                this.fechaApi.setDate(this.fechaApi.getDate() + 7);
                // Si la fecha actual es menor o igual a la última fecha en el array de fechas, cargar más huecos
                if (this.fechaApi <= new Date(this.dates[this.dates.length - 1])) {
                    this.loadMoreSlots(this.fechaApi.toISOString().split("T")[0]);
                }
            }
        },

        handleModalClose() {
            this.showErrorModal = false;
            if (this.shouldRedirect) {
                this.$router.push({ name: "Tratamiento" });
            }
            this.shouldRedirect = false; // Reset the flag
        },

        //Genera todas las fechas hasta 2 meses
        generateDates() {
            // Genera un array de fechas disponibles para citas
            const dates = [];

            // Establece la fecha de inicio como la fecha actual
            const startDate = new Date();

            // Calcula la fecha de fin (2 meses después de la fecha de inicio)
            const endDate = new Date(startDate);
            endDate.setMonth(startDate.getMonth() + 2);

            // Ajusta la fecha de fin al viernes más cercano
            endDate.setDate(endDate.getDate() - (endDate.getDay() + 2));

            // Itera desde la fecha de inicio hasta la fecha de fin
            let currentDate = new Date(startDate);
            while (currentDate <= endDate) {
                // Excluye los fines de semana (sábado y domingo)
                if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
                    // Añade la fecha al array en formato YYYY-MM-DD
                    dates.push(currentDate.toISOString().split("T")[0]);
                }
                // Avanza al siguiente día
                currentDate.setDate(currentDate.getDate() + 1);
            }

            // Devuelve el array de fechas disponibles
            return dates;
        },
        formatDay(date) {
            const day = new Date(date).toLocaleDateString("es-ES", { weekday: "short" });
            return day.charAt(0).toUpperCase() + day.slice(1); // Capitalize the first letter
        },
        formatDate(date) {
            const day = new Date(date);
            let month = day.toLocaleDateString("es-ES", { month: "short" }).slice(0, 3);
            const dayNumber = day.getDate();
            return `${dayNumber} ${month}`;
        },
        formatDateLong(date) {
            const day = new Date(date);
            return day.toLocaleDateString("es-ES", { month: "long", day: "numeric", year: "numeric" });
        },
        selectDate(date) {
            this.selectedDate = date;
            this.loadSlots(date);
        },
        isSelected(date) {
            return this.selectedDate === date;
        },
        //Carga los slots de la fecha elegida
        async loadSlots(date) {
            const daySlots = this.availableSlots.find((item) => item.date === date);
            this.slots = daySlots ? daySlots.slots : [];
        },
        //Carga los slots de fichero no de API ya no se usa
        /*async loadAvailableSlots() {
            const response = await fetch("availableSlots.json");
            this.availableSlots = await response.json();
            this.generateAvailableMonths();
        },*/
        //Controla el desplegable de los meses
        generateAvailableMonths() {
            const monthsSet = new Set();
            this.availableSlots.forEach((slot) => {
                const date = new Date(slot.date);
                const month = date.getMonth() + 1; // month is 0-based
                const year = date.getFullYear();
                const monthYear = `${month}-${year}`;
                monthsSet.add(monthYear);
            });

            this.availableMonths = Array.from(monthsSet)
                .map((monthYear) => {
                    const [month, year] = monthYear.split("-").map(Number);
                    const date = new Date(year, month - 1);
                    const monthName = date.toLocaleDateString("es-ES", { month: "long" });
                    const label = `${monthName.charAt(0).toUpperCase() + monthName.slice(1)} ${year}`;
                    return { label, value: monthYear };
                })
                .sort((a, b) => {
                    const [monthA, yearA] = a.value.split("-").map(Number);
                    const [monthB, yearB] = b.value.split("-").map(Number);
                    return new Date(yearA, monthA - 1) - new Date(yearB, monthB - 1);
                });
        },
        //Muestra el mes por defecto en el desplegable
        setDefaultMonth() {
            const today = new Date();
            const currentMonth = today.getMonth() + 1; // month is 0-based
            const currentYear = today.getFullYear();
            this.selectedMonth = `${currentMonth}-${currentYear}`;
        },
        //Muestra la clase de las citas disponibles
        getSlotClass(date) {
            const daySlots = this.availableSlots.find((item) => item.date === date);
            if (!daySlots || daySlots.slots.length == 0) {
                return "no-slots-card";
            } else if (daySlots.slots.length > 3) {
                return "many-slots-card";
            } else {
                return "few-slots-card";
            }
        },
        //Muestra el indicador de las citas disponibles
        getSlotIndicatorClass(date) {
            const daySlots = this.availableSlots.find((item) => item.date === date);
            if (!daySlots || daySlots.slots.length == 0) {
                return "no-slots";
            } else if (daySlots.slots.length > 4) {
                return "many-slots";
            } else {
                return "few-slots";
            }
        },
        //Muestra el texto de las citas disponibles
        getSlotText(date) {
            const daySlots = this.availableSlots.find((item) => item.date === date);
            if (!daySlots || daySlots.slots.length == 0) {
                return "Sin citas";
            } else if (daySlots.slots.length == 1) {
                return `${daySlots.slots.length} cita`;
            } else {
                return `${daySlots.slots.length} citas`;
            }
        },
        //Maneja las flechas de la fecha y mueve el swiper a la fecha anterior o siguiente
        slidePrev() {
            this.$refs.swiper.swiper.slidePrev();
        },
        slideNext() {
            this.$refs.swiper.swiper.slideNext();
        },
        //Si cambio el mes en el select, se mueve a la primera fecha del mes
        handleMonthChange() {
            const [month, year] = this.selectedMonth.split("-").map(Number);
            const firstDateInMonth = this.dates.find((date) => {
                const d = new Date(date);
                return d.getMonth() + 1 === month && d.getFullYear() === year;
            });
            const index = this.dates.indexOf(firstDateInMonth);
            if (index !== -1) {
                this.$refs.swiper.swiper.slideTo(index);
            }
        },
    },
};
</script>

<style scoped>
swiper-slide {
    padding: 0.5rem 0;
}
.contenedor {
    margin: 0 0.5rem;
}
.loader-overlay {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loader-container {
    display: flex;
    padding: 2rem;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: var(--blue-color);
}

.loading-spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.4rem;
}
.loading-spinner .spinner {
    width: 10px;
    height: 10px;
}
.loading-spinner p {
    font-size: 0.7rem;
    margin: 0;
    text-align: center;
}
.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid var(--pink-color);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

.select-treatment-container {
    margin-top: 2rem;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.custom-navigation {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
}

.month-select {
    margin-right: auto;
    padding: 6px 40px 6px 15px;
    height: 2rem;
    border: 1px solid var(--grey-color);
    border-radius: 5px;
    appearance: none; /* Remove default arrow */
    -webkit-appearance: none; /* Remove default arrow in Safari */
    -moz-appearance: none; /* Remove default arrow in Firefox */
    background-color: white;
    background-image: url('data:image/svg+xml;utf8,<svg data-v-7a1f3132="" height="10" width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330" xml:space="preserve"><path data-v-7a1f3132="" transform="rotate(90 165 165)" fill="%23f93f6e" d="m250.606 154.389-150-149.996c-5.857-5.858-15.355-5.858-21.213.001-5.857 5.858-5.857 15.355.001 21.213l139.393 139.39L79.393 304.394c-5.857 5.858-5.857 15.355.001 21.213C82.322 328.536 86.161 330 90 330s7.678-1.464 10.607-4.394l149.999-150.004a14.996 14.996 0 0 0 0-21.213z"></path></svg>');
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 10px 10px;
    padding-right: 30px; /* Space for the arrow */
    font-size: 0.8rem;
    font-weight: bold;
    color: var(--blue-color);
}

.month-select:focus {
    border-color: var(--pink-color);
    outline: none;
}

.nav-button {
    background-color: white;
    color: var(--pink-color);
    border: 1px solid var(--grey-color);
    padding: 0;
    border-radius: 5px;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    margin-left: 0.5rem;
}

.nav-button svg {
    fill: var(--pink-color);
}

.nav-button:hover {
    background-color: var(--light-pink-color);
    border: 1px solid var(--pink-color);
}

.day-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.7rem 0.3rem;
    background: #fff;
    border: 1px solid var(--grey-color);
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.3s;
    position: relative; /* Added for positioning the slots indicator */
}

.day-card:hover,
.day-card.selected {
    background: var(--light-pink-color);
    border-color: var(--pink-color);
    box-shadow: var(--light-pink-color) 0px 0px 0px 2px;
}

.day-card.selected .day,
.day-card.selected .date,
.day-card.selected .slots-text {
    color: var(--pink-color);
}

.day-card.no-slots-card {
    background: #f9fafb;
    border-color: #e9eaeb;
}
.day-card.no-slots-card .day,
.day-card.no-slots-card .date,
.day-card.no-slots-card .slots-text {
    color: var(--dark-grey-color);
}

.day {
    color: var(--blue-color);
    font-size: 0.8rem;
    font-weight: bold;
}

.date {
    margin-top: 5px;
    font-size: 0.9rem;
    font-weight: bold;
    color: var(--pink-color);
}

.slots {
    margin-top: 20px;
}

.slots-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.slot-item {
    padding: 10px;
    background-color: var(--light-pink-color);
    border: 1px solid var(--soft-pink-color); /* Using the primary color variable */
    border-radius: 8px;
    text-align: center;
    color: var(--pink-color);
    font-weight: bold;
    cursor: pointer;
}

.slots p {
    color: red;
    font-weight: bold;
}

.horacita {
    color: var(--blue-color) !important;
    text-align: center;
    margin-top: 1.5rem;
}

.slots-container {
    display: flex;
    align-items: center;
    padding-top: 0.5rem;
}

.slots-text {
    font-size: 0.6rem;
    padding-left: 3px;
}

.slots-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--blue-color);
    font-size: 10px;
    font-weight: bold;
}

.many-slots {
    background-color: #27bb73;
}

.few-slots {
    background-color: #fec545;
}

.no-slots {
    background-color: gray;
    display: none;
}

.meeting-info {
    display: flex;
    font-size: 0.8rem;
    font-weight: bold;
    justify-content: space-between;
    margin-bottom: 1rem;
}
.meeting-info .duracion {
    display: flex;
}
.meeting-info .duracion span {
    margin-left: 0.2rem;
}
.cita-header {
    display: flex;
    align-items: center;
    margin: 0 0.5rem;
    margin-bottom: 2rem;
}
.cita-header .titulo {
    font-size: 20px;
    font-weight: bold;
}
@media (min-width: 768px) {
    .select-treatment-container {
        margin-top: 4rem;
    }
}
</style>
